document.addEventListener('DOMContentLoaded', function () {
  initGsapCommon();
  initFeaturePageTop();
});

document.addEventListener('shopify:section:load', function () {
  initGsapCommon();
  initFeaturePageTop();
});

function initGsapCommon() {
  if (typeof gsap === 'undefined') return;

  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  if (typeof ScrollToPlugin !== 'undefined') {
    gsap.registerPlugin(ScrollToPlugin);
  }

  const animations = {
    'fade-in': {
      from: { opacity: 0 },
      to: { opacity: 1 }
    },

    'fade-up': {
      from: { y: 48, opacity: 0 },
      to: { y: 0, opacity: 1 }
    },

    'fade-down': {
      from: { y: -48, opacity: 0 },
      to: { y: 0, opacity: 1 }
    },

    'slide-left': {
      from: { x: 80, opacity: 0 },
      to: { x: 0, opacity: 1 }
    },

    'slide-right': {
      from: { x: -80, opacity: 0 },
      to: { x: 0, opacity: 1 }
    },

    'slide-up': {
      from: { y: 80, opacity: 0 },
      to: { y: 0, opacity: 1 }
    },

    'slide-down': {
      from: { y: -80, opacity: 0 },
      to: { y: 0, opacity: 1 }
    },

    'zoom-in': {
      from: { scale: 0.94, opacity: 0 },
      to: { scale: 1, opacity: 1 }
    },

    'blur-in': {
      from: { y: 32, opacity: 0, filter: 'blur(12px)' },
      to: { y: 0, opacity: 1, filter: 'blur(0px)' }
    }
  };

  document.querySelectorAll('.js-gsap').forEach(function (el) {
    if (el.dataset.gsapInitialized === 'true') return;

    const type = el.dataset.gsap || 'fade-up';

    if (type === 'none') {
      el.style.opacity = 1;
      el.dataset.gsapInitialized = 'true';
      return;
    }

    const animation = animations[type];

    if (!animation) return;

    const duration = Number(el.dataset.gsapDuration || 1);
    const delay = Number(el.dataset.gsapDelay || 0);
    const start = el.dataset.gsapStart || 'top 85%';
    const ease = el.dataset.gsapEase || 'power3.out';
    const once = el.dataset.gsapOnce !== 'false';

    gsap.fromTo(
      el,
      animation.from,
      {
        ...animation.to,
        duration: duration,
        delay: delay,
        ease: ease,
        scrollTrigger: {
          trigger: el,
          start: start,
          once: once
        }
      }
    );

    el.dataset.gsapInitialized = 'true';
  });
}

function initFeaturePageTop() {
  document.querySelectorAll('.js-feature-pagetop').forEach(function (button) {
    if (button.dataset.pagetopInitialized === 'true') return;

    button.addEventListener('click', function () {
      if (typeof gsap !== 'undefined' && typeof ScrollToPlugin !== 'undefined') {
        gsap.registerPlugin(ScrollToPlugin);

        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: 0
          },
          ease: 'power3.inOut'
        });

        return;
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    button.dataset.pagetopInitialized = 'true';
  });
}